<template>
  <b-container fluid>
    <backlink />
    <h1>Produits</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="type" slot-scope="{ data }">
        {{ $store.getters["product/getType"](data.value) ? $store.getters["product/getType"](data.value).text : data.value }}
      </template>
      <template slot="child_product_type" slot-scope="{ data }">
        {{ data.value ? $store.getters["product/getChildType"](data.value).text : null }}
      </template>
      <template slot="group_slug" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value.includes('outillage')" variant="outillage" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-if="data.value.includes('instruments')" variant="instruments" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-if="data.value.includes('service_et_logistique')" variant="service_et_logistique"
            class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
      <template slot="actions" slot-scope="{ data }">
        <b-button v-if="data.item.type == 'selling'" @click.prevent="openMovement(data.item)"
          v-b-tooltip.hover title="Enregistrer un mouvement de stock" variant="outline-secondary">
          <i class="far fa-box-open"></i>
        </b-button>
      </template>
    </AdminTable>

    <StockMovementModal ref="movementModal" />
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";
import StockMovementModal from "./StockMovementModal";

export default {
  name: "ProductList",
  components: {
    AdminTable,
    StockMovementModal,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      let status_options = this.$store.getters["status/getByGroup"]("product")
        .selectOptions("status_slug", "name")
        .filter(
          (item) => item.value != "product-add-stock" && item.value != "product-remove-stock"
        )
      return {
        status_options: [
          status_options[1],
          status_options[0],
        ],
        // « Produits » ne montre que le catalogue : la nature « Location pour compte »
        // ne s'administre que depuis « Produits spéciaux », son filtre n'a rien à y faire.
        type_options: this.$store.getters["product/getCatalogTypes"],
        equipment_group_options: this.$store.getters["equipment_group/getAllForSelect"],
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
        child_product_type_options: this.$store.getters['product/getChildTypesForSelect'],
        from_mcs_options: [
          { value: null, text: "Toutes" },
          { value: '1', text: "Import MCS" },
          { value: '0', text: "Catalogue ESM" },
        ],
        pricing_options: [
          { value: null, text: "Toutes" },
          { value: 'none', text: "Sans aucun prix" },
          { value: 'esm', text: "Grille ESM" },
          { value: 'mcs', text: "Grille MCS" },
          { value: 'axiloc', text: "Grille Axiloc (historique)" },
          { value: 'axiloc_only', text: "Grille Axiloc seulement (sans ESM)" },
        ],
        warehouse_options: [
          { value: "none", text: "Aucun entrepôt" },
          ...this.$store.getters["warehouse/getAll"].selectOptions("id", [
            "internal_code",
            " - ",
            "name",
          ]),
        ],
        // Pas d'entrée « tous » ici : le select pose déjà « -- Tout -- » dans son slot
        // `first`, la répéter afficherait deux lignes équivalentes.
        weight_status_options: [
          { value: 'missing', text: "Non renseigné (vide ou 0)" },
          { value: 'filled', text: "Renseigné" },
        ],
      };
    },
  },
  mounted() {
    this.$store.dispatch("equipment_group/getAll");
    this.$store.dispatch("warehouse/getAll");

    // ?movement=<id> : la modale de mouvement de stock est rouverte au chargement
    const movementId = parseInt(this.$route.query.movement);
    if (movementId) {
      this.$store.dispatch(this.config.storeNamespace + "/getItem", { id: movementId }).then(() => {
        const product = this.$store.getters[this.config.storeNamespace + "/getItem"](movementId);
        if (product && product.type == "selling") {
          this.openMovement(product);
        } else {
          this.$refs.movementModal.setInUrl(null);
        }
      });
    }
  },
  methods: {
    openMovement(product) {
      this.$refs.movementModal.open(product);
    },
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;

      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "product", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              statusSlug: ctx.extended_filters_model.status,
              type: ctx.extended_filters_model.type,
              group_slug: ctx.extended_filters_model.group_slug,
              equipment_group: ctx.extended_filters_model.equipment_group,
              child_product_type: ctx.extended_filters_model.child_product_type,
              from_mcs: ctx.extended_filters_model.from_mcs,
              pricing: ctx.extended_filters_model.pricing,
              weight: ctx.extended_filters_model.weight_status,
              warehouse: ctx.extended_filters_model.warehouse,
              parents: false
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.products || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Product/ProductList.vue